import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch,useAppSelector } from '../../../app/hooks';
import { deleteCostCenterAsync, getAccountCostCenterByIdAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, UpdateCostCenterAsync,updateSorting } from './costCenterSlice';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import clsx from 'clsx';
import { ShowToast } from '../../../common/Toastr';
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';

const CostCenterItem = (props: any) => {
    const { costCenterList, t, onopenModal, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn,pageSize } = useAppSelector((state) => state.costCenter);

    const dispatch = useAppDispatch();

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountCostCenterId: number) => {
        dispatch(getAccountCostCenterByIdAsync(AccountCostCenterId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const onDeleteClick = (AccountCostCenterId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteCostCenterAsync(AccountCostCenterId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Cost Center Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });

    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, costCenter: any) => {
        const { checked } = e.target;
        const foundIndex = costCenterList.findIndex((item: any) => item.AccountCostCenterId === costCenter.AccountCostCenterId);
        if (foundIndex !== -1) {
            const foundItem = costCenterList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...costCenterList.slice(0, foundIndex), updatedItem, ...costCenterList.slice(foundIndex + 1)];
            dispatch(UpdateCostCenterAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("CostCenter Update Successfully", 'Success', "success", "toast-top-right");

                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");

                })
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>

            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle">
                    <th className='w-25'>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}
                    {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                    </th>
                        <th className='w-25'>
                            {/* {t('Code')} */}
                            {getValueFromResource('Code',dispatch, t)}
                        {sortColumn === 'AccountCostCenterCode' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountCostCenterCode") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountCostCenterCode") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountCostCenterCode") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountCostCenterCode") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-35'>
                            {/* {t('Cost Center')} */}
                            {getValueFromResource('Cost Center',dispatch, t)}
                        {sortColumn === 'AccountCostCenter' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountCostCenter") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountCostCenter") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountCostCenter") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountCostCenter") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* {IsEdit &&
                            <th className='w-25'>{t('Active / Inactive')}</th>
                        } */}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {costCenterList.length > 0 && costCenterList.map((costCenterDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(costCenterDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {costCenterDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">{costCenterDetail.AccountCostCenterCode}</span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(costCenterDetail.AccountCostCenterId) : undefined}
                            >
                                <span className="d-block">{costCenterDetail.AccountCostCenter}</span>
                            </td>
                            {/* {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={costCenterDetail.IsDisabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, costCenterDetail) }}
                                        /> 
                                        
                                    </div>
                                </td>
                            } */}

                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                        {IsEdit &&
                                            <>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onEditClick(costCenterDetail.AccountCostCenterId) }}
                                                    >

                                                        <span className="menu-icon custom-menu">
                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {/* {`${t('Edit')}`} */}
                                                            {getValueFromResource('Edit',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                        {IsDelete && IsEdit && (costCenterDetail.MasterCostCenterId === null || costCenterDetail.MasterCostCenterId === 0) &&
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                                        }
                                        {IsDelete === true && (costCenterDetail.MasterCostCenterId === null || costCenterDetail.MasterCostCenterId === 0) &&
                                            <>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onDeleteClick(costCenterDetail.AccountCostCenterId) }}
                                                    >
                                                        <span className="menu-icon  custom-menu">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                            {/* {`${t('Delete')}`} */}
                                                            {getValueFromResource('Delete',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {costCenterList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p>
                </div>
            }


        </>
    )
}
export default CostCenterItem